import {ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {FormBuilder, FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {EventEmitter} from 'protractor';
import {environment} from '../../../environments/environment';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  ParamMap,
  Router,
  RouterEvent
} from '@angular/router';
//import {toTitleCase} from 'codelyzer/util/utils';
import {AppService} from '../../services/app.service';
import * as $ from 'jquery';

declare var UIkit: any;
import {timeStamp} from 'console';
import {FacebookLoginProvider, GoogleLoginProvider, SocialAuthService} from 'angularx-social-login';
import {AuthenticationService} from '../../services/authentication.service';
import {UserService} from '../../services/user.service';
import {User} from '../../_models/user.model';

declare var icogz: any;


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit, OnDestroy {

  public loginPayLoad = {mobile_number: '', otp: '', user_id: ''};
  public profilePayLoad = {first_name: '', last_name: '', email: '', city: ''};
  @ViewChild('OTPForm') OTPForm: NgForm;

  public loginResponseReceived = false;
  public responseAwaited = false;
  public OTPReceived = false;
  public errorMessage = '';
  public accessToken = '';
  public firstName = '';
  public lastName = '';
  public _extraClass = '';
  public displayDarkNavigation = false;
  public isStandardProduct = false;
  public headerSelectedCity;
  public _displayProductSwitch = true;
  public hideSignupButtons = false;
  public serverError = '';
  public social_step_2 = false;
  public searchKeyword = '';

  // for categories
  categoriesReceived = false;
  categories: any = [];
  currentCategoryID = '';
  currentCategorySlug = '';


  // resendOTP
  public resendOTPinProgress = false;
  public receivedResentOTPResponse = false;

  @Input()
  get extraClass(): string {
    return this._extraClass;
  }

  set extraClass(flag: string) {
    this._extraClass = flag;
  }

  @Input()
  get standardProduct(): boolean {
    return this.isStandardProduct;
  }

  set standardProduct(flag: boolean) {
    this.isStandardProduct = flag;
  }

  @Input()
  set displayNavigation(flag: boolean) {
    this.displayDarkNavigation = flag;
  }

  @Input()
  get displayProductSwitch(): boolean {
    return this._displayProductSwitch;
  }

  set displayProductSwitch(flag: boolean) {
    this._displayProductSwitch = flag;
  }

  currentUser: User;
  profileForm: FormGroup = this.fb.group({
    email: [{value: ''}, [Validators.required, Validators.email]],
    first_name: [{value: '',}, [Validators.required, Validators.max(255)]],
    last_name: [{value: '',}, [Validators.required, Validators.max(255)]],
    city: [{value: ''}, Validators.required],
  });
;

  constructor(
    private http: HttpClient,
    private router: Router,
    private activedRoute: ActivatedRoute,
    public appService: AppService,
    private authService: SocialAuthService,
    private authenticateService: AuthenticationService,
    private userService: UserService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef
  ) {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.authenticateService.currentUser.subscribe(x => {
      this.currentUser = x;
    });

  }


  ngOnDestroy(): void {
    $('.citymodel').eq(2).remove();
  }

  ngOnInit(): void {
    // setup the form

    if (!localStorage.getItem('isEnc')) {
      localStorage.clear();
      localStorage.setItem('isEnc', 'true');
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        UIkit.modal('.citymodel').hide();
      }
    });

    this.hideSignupButtons = false;
    this.loginPayLoad.mobile_number = '';
    this.loginPayLoad.otp = '';
    this.serverError = '';
    this.social_step_2 = false;

    this.accessToken = localStorage.getItem('accessToken');
    this.firstName = this.appService.getDisplayName();

    $('html').removeClass('overflow-hidden');
    $('html').removeClass('overflow-hidden');
    $('html').removeClass('uk-modal-page');

    // get selected city
    this.headerSelectedCity = localStorage.getItem('city');
    console.log('city in header', this.headerSelectedCity);
    // check if city is present in the URL

    const cityFromURL = this.router.url.toString().split('/')[1];
    if (cityFromURL.toLowerCase() === 'mumbai' || cityFromURL.toLowerCase() === 'pune' || cityFromURL.toLowerCase() === 'bangaluru' || cityFromURL.toLowerCase() === 'delhi') {
      localStorage.setItem('city', cityFromURL.toLowerCase());
      this.headerSelectedCity = cityFromURL.toLowerCase();
      this.appService.setlocationSetByTheUser();
    }

    if (this.headerSelectedCity === null || this.headerSelectedCity === 'undefined' || this.headerSelectedCity === undefined || this.headerSelectedCity === '') {
      this.headerSelectedCity = 'Mumbai';
      localStorage.setItem('city', 'Mumbai');


      if (!this.router.url.toString().split('/')[2] || this.router.url.toString().split('/')[2] === undefined) {
        // this.router.navigate(['/c/' + this.headerSelectedCity.toLowerCase()]);
      }
    }

    console.log('City', this.headerSelectedCity);

    this.getCategories();

    // add the default header class after 500ms
    setTimeout(f => {
      if (this.displayDarkNavigation) {
        $('.header-wrp').addClass('nav-down text-gray');
        $('.middle-panel').removeClass('scrolltoshow');
        $('.logo-box').removeClass('scrolltoshow');
        $('.location-dropdown').removeClass('scrolltoshow');
        $('.welcome-user').find('img').addClass('brigtness-black');
      }
    }, 500);
    $(document).mouseup(function(e) {
      var container = $('#main-ham');
      // If the target of the click isn't the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {

        $('.hamburger-menu-main').removeClass('hamburger-menu-right');
        $('.hamburger-overlay').removeClass('overlay-2');
        $('.openMenu').children('i').removeClass('fa-close').addClass('fa-bars');
        $('html').removeClass('overflow-hidden');
        $('html').removeClass('uk-modal-page');
      }
    });

    $(document).mouseup(function(e) {
      var container = $('.sharelink');
      // If the target of the click isn't the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        if ($('.sharelink:visible').length == 1) {
          setTimeout(() => {                           // <<<---using ()=> syntax
            $('.sharelink').slideUp();
          }, 200);
        }
      }
    });

    $('.citymodel').eq(2).remove();
  }

  /**
   * Scroll listener to remove and show the navigation
   *
   * @param $event
   */
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {

    if (!this._extraClass) {
      if ($(document).scrollTop() > $(window).height()) {
        $('.header-wrp').addClass('nav-down text-gray');
        $('.middle-panel').removeClass('scrolltoshow');
        $('.logo-box').removeClass('scrolltoshow');
        $('.location-dropdown').removeClass('scrolltoshow');
        $('.welcome-user').find('img').addClass('brigtness-black');

      } else {
        $('.header-wrp').removeClass('nav-down text-gray');
        $('.middle-panel').addClass('scrolltoshow');
        $('.location-dropdown').addClass('scrolltoshow');
        $('.welcome-user').find('img').removeClass('brigtness-black');
        $('.logo-box').addClass('scrolltoshow');
      }
    } else {
      $('.header-wrp').addClass('nav-down text-gray');
      $('.middle-panel').removeClass('scrolltoshow');
      $('.logo-box').removeClass('scrolltoshow');
      $('.location-dropdown').removeClass('scrolltoshow');
      $('.welcome-user').find('img').addClass('brigtness-black');
    }
  }


  closeMenu(): void {
    $('.hamburger-menu-main').removeClass('hamburger-menu-right');
    $('.hamburger-overlay').removeClass('overlay-2');
    $('.openMenu').children('i').removeClass('fa-close').addClass('fa-bars');
    $('html').removeClass('overflow-hidden');
    $('html').removeClass('uk-modal-page');
  }

  openMyAccount(): void {
    this.router.navigate(['/my-account']);
  }


  resendOTP(): void {
    if (this.loginPayLoad.mobile_number.length !== 10) {
      this.errorMessage = 'Mobile Number must be of 10 digits.';
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.resendOTPinProgress = true;

    this.http.post<any>(environment.domain + '/api/register', this.loginPayLoad, httpOptions).subscribe(
      data => {
        if (data.type === 'success') {
          this.loginPayLoad.user_id = data.user;
          this.OTPForm.reset();

        }
        this.resendOTPinProgress = false;
        this.receivedResentOTPResponse = true;
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
        this.errorMessage = error.error.mobile_number;
        this.resendOTPinProgress = true;
      });
  }

  /**
   * Mobile number OTP verification
   * - Store access token
   */
  doOTPVerification(): void {
    this.responseAwaited = true;
    this.authenticateService.loginByOtp(this.loginPayLoad).subscribe(
      data => {

        this.loginResponseReceived = true;
        if (data.mobile_number_invalid === true) {
          this.OTPReceived = false;
          return;
        }
        if (data.type === 'error') {
          this.errorMessage = data.error_msg;
        } else {
          this.accessToken = data.access_token;
          icogz.trackEvent(JSON.stringify({user_id: data.profile.id}), 'user_loggedin');
          this.OTPReceived = false;
          this.showProfilePopup(data);
          this.appService.triggerUserLoggedIn();
        }
        this.responseAwaited = false;
      },
      error => {
        console.error('There was an error!', error);
        this.responseAwaited = false;
      });
  }

  /**
   * Update profile if first time user.
   */
  updateProfile() {
    this.validateAllFormFields(this.profileForm);
    if (!this.profileForm.valid) {
      return;
    }
    this.responseAwaited = true;
    /*by kanika : If the profile is not complete then ask for the profile
     * if (this.loginPayLoad.otp === '') {
      return false;
    }*/
    this.userService.update(this.profileForm.value).subscribe(
      data => {
        if (data.type === 'error') {
          this.errorMessage = data.error_msg;
        } else {
          UIkit.modal('#modal-center').hide();
          if (data.user_has_profile === false) {
            UIkit.modal('#modal-profile').show();
          }
          UIkit.modal('#modal-profile').hide();
        }
        this.responseAwaited = false;
      },
      error => {
        console.error('There was an error!', error);
        if (error.status == 422) {
          this.errorMessage = 'Email is already taken';
        }
        this.responseAwaited = false;
      });
  }

  showSearchForm() {
    $('.search-sidenav-wrp').addClass('hamburger-menu-right');
    $('.search-box').focus();
    $('.autocomplete-container input').focus();
  }

  closeSearchForm() {
    $('.search-sidenav-wrp').removeClass('hamburger-menu-right');
  }

  /**
   * Clear session and logout from the system.
   */
  doLogout(): void {
    this.hideSignupButtons = false;
    this.loginPayLoad.mobile_number = '';
    this.authenticateService.logout();
    this.authService.signOut().then().catch(data => {
    });
    this.accessToken = '';
    this.appService.triggerUserLoggedOut();
  }

  hideLogout(): void {
    UIkit.drop('.logout-drop').hide();
  }


  /**
   * Save city
   *
   * @param city
   */
  selectCity(city): void {
    UIkit.modal('.citymodel').hide();

    localStorage.setItem('city', city);
    this.headerSelectedCity = city;
    this.appService.cityChanged(city);
    this.appService.setlocationSetByTheUser();
    UIkit.modal('.hamburger-menu-main').hide();
    $('html').removeClass('overflow-hidden');
    $('html').removeClass('uk-modal-page');
    $('.hamburger-menu-main').removeClass('uk-modal');
    this.router.navigate(['/' + city.toLowerCase() + '/exclusives']);
  }

  /**
   * Close city selection
   *
   * @param e
   */
  closeCitySelection(e): void {
    $('.hide-city').slideUp();
    $('html').removeClass('overflow-hidden');
  }

  toggleMobileExperiences(e): void {
    $('.uk-accordion-content').toggle();
  }

  /**
   * load categories
   */
  getCategories(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.http.post<any>(environment.domain + '/api/categories', {}, httpOptions).subscribe(
      data => {
        this.categoriesReceived = true;
        this.categories = data.categories;

        this.categories.EXPERIENCE.forEach((category, index) => {
          if (category.category_name.toLowerCase() === this.currentCategorySlug) {
            this.currentCategoryID = category.id;
          }
        });

        this.categories.STANDARD.forEach((category, index) => {
          if (category.category_name.toLowerCase() === this.currentCategorySlug) {
            this.currentCategoryID = category.id;
          }
        });
      },
      error => {
        console.error('There was an error!', error);
      });
  }

  /**
   * Open Hamburger menu
   * @param e
   */
  openMenu(e): void {
    e = $(e);
    $('.hamburger-menu-main').addClass('hamburger-menu-right');
    $('.hamburger-overlay').addClass('overlay-2');
    // $('.hamburger-menu-main').toggle('fast');
    // $('.hide-search').hide();
    if ($('.hamburger-menu-main').css('display') == 'block') {
      $('html').addClass('overflow-hidden');
    }


    // $('.openSearch').children('i').removeClass('fa-close').addClass('fa-search');

    // change icon on click
    if (e.children('i').hasClass('fa-bars')) {
      e.children('i').removeClass('fa-bars');
      e.children('i').addClass('fa-close');
    } else {
      e.children('i').addClass('fa-bars');
      e.children('i').removeClass('fa-close');
    }
  }

  showCitySelection(e): void {
    UIkit.modal('.citymodel').show();
  }

  changeMobileNumber(): void {
    this.OTPReceived = false;
  }

  /**
   * User Authentication
   */
  doLogin(): void {
    if (this.loginPayLoad.mobile_number.length !== 10) {
      this.errorMessage = 'Mobile Number must be of 10 digits.';
      return;
    }
    this.hideSignupButtons = true;
    this.responseAwaited = true;
    this.authenticateService.register(this.getLoginPayloadForRegister()).subscribe(
      data => {
        this.loginResponseReceived = true;
        if (data.type === 'success') {
          this.OTPReceived = true;
          this.responseAwaited = false;
          this.loginPayLoad.user_id = data.user;
          this.errorMessage = '';
        }
      },
      error => {
        this.hideSignupButtons = false;
        console.error('There was an error!', error);
        console.error(error.error);
        this.errorMessage = error.error.mobile_number;
        this.responseAwaited = false;
      });
  }

  signInWithSocial(provider): void {
    var providerId;
    this.social_step_2 = false;
    switch (provider) {
      case 'google':
        providerId = GoogleLoginProvider.PROVIDER_ID;
        break;
      case 'facebook':
        providerId = FacebookLoginProvider.PROVIDER_ID;
        break;
      default:
        throw ('not implemnt exception');
    }
    this.authService.signIn(providerId).then(x => {
      this.authenticateService.socialLogin(provider, x).subscribe(
        data => {
          this.hideSignupButtons = false;
          this.showProfilePopup(data);
        },
        error => {
          switch (error.status) {
            case 422:
            case 404:
              UIkit.modal('#modal-center').show();
              this.social_step_2 = true;
              this.hideSignupButtons = true;
              return;
            default:
              UIkit.modal('#modal-center').show();
              this.errorMessage = error.error;
          }
          return error;
        });
    });

  }

  refreshToken(): void {
    this.authService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }

  private getLoginPayloadForRegister() {
    var _loginPayload = [];
    _loginPayload['mobile_number'] = this.loginPayLoad.mobile_number;
    _loginPayload['otp'] = this.loginPayLoad.otp;
    _loginPayload['user_id'] = this.loginPayLoad.user_id;
    this.authService.authState.subscribe(x => {
      if (x) {
        _loginPayload['social_link'] = true;
        _loginPayload['provider'] = x.provider;
        _loginPayload['provider_email'] = x.email;
        _loginPayload['first_name'] = x.firstName;
        _loginPayload['last_name'] = x.lastName;
        _loginPayload['photo'] = x.photoUrl;
        _loginPayload['provider_id'] = x.id;
      }
    });
    return Object.assign({}, _loginPayload);
  }

  private showProfilePopup(data) {
    UIkit.modal('#modal-center').hide();
    console.log(data);
    if (data.user_has_profile === false) {
      UIkit.modal('#modal-profile').show();
    }
    if (this.currentUser) {
      this.profileForm.controls.first_name.setValue(this.currentUser.first_name);
      this.profileForm.controls.last_name.setValue(this.currentUser.last_name);
      this.profileForm.controls.email.setValue(this.currentUser.email);
      this.profileForm.controls.city.setValue(this.currentUser.city);
    }
    this.appService.triggerUserLoggedIn();
    UIkit.modal('#modal-center').hide();
  }


  validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  searchProducts(): void {
    const keyword = localStorage.getItem('searchKeyword');

    if (this.isStandardProduct) {
      this.router.navigate(['/' + this.headerSelectedCity + '/deals/search/' + keyword]);
    } else {
      this.router.navigate(['/' + this.headerSelectedCity + '/exclusives/search/' + keyword]);
    }
  }
}
